import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { BadgeCheck, GitCompareArrows } from "lucide-react";
import { SecondaryNav } from "@client/components/secondary-nav";

export const Route = createFileRoute("/_app/truth")({
  component: TruthLayout,
});

const truthItems = [
  {
    title: "验收轮次",
    to: "/truth" as const,
    icon: BadgeCheck,
    exact: true,
  },
  {
    title: "产物对比",
    to: "/truth/compares" as const,
    icon: GitCompareArrows,
  },
];

/** 沉浸路径（评分页 /truth/rounds/{id} / 对比详情页 /truth/compares/{id}）：隐藏二级目录，裸 Outlet 占满（主侧栏已在 _app 层隐藏） */
function isImmersive(pathname: string): boolean {
  if (pathname.startsWith("/truth/rounds/")) return true;
  // 列表页 /truth/compares 保留目录；其下详情 /truth/compares/:id 进入沉浸
  return pathname.startsWith("/truth/compares/") && pathname !== "/truth/compares";
}

function TruthLayout() {
  const { pathname } = useLocation();
  if (isImmersive(pathname)) {
    return (
      <div className="h-full min-h-0 w-full min-w-0">
        <Outlet />
      </div>
    );
  }
  return <SecondaryNav title="Truth 验收" items={truthItems} />;
}
